import { Edit } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import DataTable from 'components/DataTable'
import React from 'react'
import _ from 'lodash'
import ButtomEditNewReuniao from 'entity/Rodada/components/PainelControle/ButtomEditNewReuniao'

const txtProdutos = (produtos) => {
  let r = ""
  produtos?.forEach(p => {
    r += p.nome + "; "
  })
  return r
}
export default function MatchsIncricao({
  incricao,
  index,
  inscricoes,
  matchs,
  updateReuniao,
  rodada,
  reunioes,
  getReunioesInscricao,
  overSaveReuniao,
  editOnlyP2,
  mesa,
}) {
  let { empresa: { produtosVenda, produtosCompra } } = incricao
  produtosVenda = produtosVenda?.map(p => p.produto)
  produtosCompra = produtosCompra?.map(p => p.produto)


  if (rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor") && !mesa) {
    return <Box sx={{ display: "flex", justifyContent: "center", color: 'text.disabled', margin: '8em' }}>
      <Typography variant='h6'>- ATRIBUA UMA MESA A ESTE ÂNCORA -</Typography>
    </Box>
  }

  return <Box>
    <Typography variant='caption'>Produtos Vender: {txtProdutos(produtosVenda)}</Typography>
    <br />
    <Typography variant='caption'>Produtos Comprar: {txtProdutos(produtosCompra)}</Typography>
    <Typography variant='h6'>Matchs:</Typography>

    <DataTable
      idField={'uid'}
      rows={matchs || []}
      columns={[
        {
          field: "empresa.nomeEmpresaCracha",
          headerName: "Participante",
          flex: 2,
          renderCellValue: (row) => <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography style={{ flex: 1, textAlign: 'initial' }}>
              {_.get(row, "empresa.nomeEmpresaCracha")} {_.get(row, "mesa.name") ? (` - ${_.get(row, "mesa.name")}`) : ''}
            </Typography>
            <IconButton onClick={() => window.open("/#/inscricao?uid=" + row.uid, '_blank')}><Edit /></IconButton>
          </Box>,
        },
        {
          field: "uid2", headerName: "Mesa", flex: 1,
          valueGetter: ({ row }) => {
            if (rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor")) {
              if (incricao.mesa) {
                return incricao.mesa.name
              }
              return '-'
            } else {
              let reunioesi = getReunioesInscricao(incricao.uid, row.uid)

              if (reunioesi && reunioesi.length) {
                return reunioesi[0].mesa.name
              }
              return '-'
            }
          }
        },
        {
          field: "empresa.Uid",
          headerName: "Num. Reuniões", flex: 1,
          renderCellValue: (row) => <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography style={{ flex: 1, textAlign: 'initial' }}>{getReunioesInscricao(_.get(row, "uid"))?.length}</Typography>
          </Box>,
        },
        {
          field: "empresa.produtosVenda", headerName: "Matchs Produtos", flex: 2,
          valueGetter: ({ row }) => {
            let aux = row.matchsProdutos.map(p => p.produto ? p.produto : p)
            let h = "(" + row.matchsProdutos.length + ") " + txtProdutos(aux);
            return h || "-"
          }
        },
        {
          field: "uid", headerName: "Horário da Reunião", flex: 2,
          valueGetter: ({ row }) => {
            let reunioes = getReunioesInscricao(incricao.uid, row.uid)
            // console.log('reunioes',reunioes)  

            if (reunioes && reunioes.length) {
              return reunioes[0].horariotxt
            }
            return '-'
          }
        },
        {
          field: "empresa.cnpj",
          headerName: "Ações", flex: 1,
          renderCellValue: (row) => {
            let initial = { status: "ATIVO", rodada: rodada, inscricao1: incricao, inscricao2: row, }
            let reunioesi = getReunioesInscricao(incricao.uid, row.uid)

            if (reunioesi && reunioesi.length) {
              initial = reunioesi[0]
            }


            return <Box>

              <ButtomEditNewReuniao
                mesa={mesa}
                editOnlyP2={editOnlyP2}
                rodada={rodada}
                reunioes={reunioes}
                inscritos={inscricoes}
                overSaveReuniao={overSaveReuniao}
                initialValues={initial}
                disabledField={{ inscricao1: true, inscricao2: true }}
              />

              {/* <DialogAgendar
                                getReuniao={getReuniaoFlutuante}
                                getReunioes={getReunioes}
                                temAgendamentoNoHorarioGlobal={temAgendamentoNoHorarioGlobal}
                                showWarning={showWarning}
                                reunioes={reunioes}
                                updateReuniao={updateReuniao}
                                participanteRow={row}
                                participanteTab={flutuante}
                                mesa={rodada.mesas.find(m => m.uid === row.mesa?.uid)}
                                setParticipante2={setParticipante1}
                                removeParticipante2={removeParticipante1}
                            /> */}
            </Box>
          },
        },
      ]}

      autoHeight
    />


    <Typography variant='h6'>Reuniões:</Typography>

  </Box>
}